<template>
  <div class="menu-nav" id="sidebarId">
    <ul class="menu-ul">
      <li
        :class="[route.meta && (curHref.indexOf(route.meta.path) == 0 || curMove == route.code)?'menu-active':'',isShowTitle?'':'li-min']"
        :key="route.path"
        @click="getCurRouter(route,'',route.path)"
        @mouseenter="enter(route.code)"
        @mouseleave="leave()"
        v-for="route of permission_routers"
        v-show="route.children && route.isShow"
      >
        <app-link :key="route.code" :to="resolvePath(route.path)">
          <div class="menu-ul-div">
            <div :class="[route.icon,isShowTitle?'div-icon-max':'div-icon-min','div-icon']"></div>
            <transition
              enter-active-class="animated fadeInLeft"
              leave-active-class="animated fadeOutLeft"
              name="fade"
            >
              <p class="title" v-show="isShowTitle">{{ route.title | formatTitle }}</p>
            </transition>
            <div
              @click="showTitle"
              class="slider-div"
              v-if="route.meta && (curHref.indexOf(route.meta.path) == 0 || curMove == route.code)"
            >
              <img alt src="../../assets/menu-icon/icon_slider@2x.png" />
            </div>
          </div>
        </app-link>
        <transition name="el-zoom-in-left">
          <div
            :class="[isShowTitle?'sub-menu-max':'sub-menu-min','sub-menu']"
            v-if="route.children && route.children.length>1 && curMove == route.code"
          >
            <ul>
              <li
                :class="curClickTo == item.code?'sub-active':''"
                :key="item.code"
                @click="getCurRouter(route,item)"
                @mouseenter="enterTo(item.code)"
                @mouseleave="leaveTo()"
                v-for="item of route.children"
              >
                <app-link :key="item.code" :to="resolvePath(item.path)">
                  <div class="menu-sub-div">
                    <p class="sub-title">{{ item.title }}</p>
                  </div>
                </app-link>
              </li>
            </ul>
          </div>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex'
import path from 'path'
import pathToRegexp from 'path-to-regexp'
import AppLink from '@/layout/components/Link'
export default {
  name: 'Sidebar',
  components: { AppLink },
  data () {
    return {
      isShowTitle: true,
      curMove: '',
      curHref: "",
      curClick: '',
      curClickTo: '',
      curPage: '',
      curPageTo: ''
    }
  },
  filters: {
    formatTitle (value) {
      if (value) {
        return value.replace(/模块/g, '')
      } else {
        return value;
      }
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb();
      if (this.subList && this.subList.children && this.subList.children.length > 1) {
        for (let item of this.subList.children) {
          if (item.meta.path == this.curHref) {
            store.dispatch('getSubChildrenRouter', item);
            this.curPageTo = item.code
            break
          } else {
            this.curPageTo = ''
          }
        }
        this.curClickTo = this.curPageTo
      }
    }
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'subList',
      'tagSet'
    ])
  },
  mounted () {
    this.$nextTick(() => {
      this.getBreadcrumb();
      this.getCurRouter();
    })
  },
  methods: {
    showTitle () {
      this.isShowTitle = !this.isShowTitle
      this.$emit("isShowMin");
    },
    enter (code) {
      this.curClick = code;
      this.curMove = code;
    },
    enterTo (code) {
      this.curClickTo = code;
    },
    leave () {
      this.curClick = this.curPage
      this.curMove = '';
    },
    leaveTo () {
      this.curClickTo = this.curPageTo;
    },
    resolvePath (routePath) {
      return path.resolve(routePath)
    },
    getCurRouter (route, subRouterTo, path) {
      if (this.permission_routers === null) {
        return false;
      }
      let subRouter;
      let current;
      /*首次登陆系统*/
      if (route === undefined) {
        for (let router of this.permission_routers) {
          if (router.children) {
            for (let routerSub of router.children) {
              if (routerSub.meta.path == this.curHref) {
                subRouter = router
                break
              }
            }
          }
        }
        current = this.curHref
      } else {
        if (subRouterTo) {
          store.dispatch('removeCacheView', { name: subRouterTo.meta.name })
          store.dispatch('setTagId', { name: subRouterTo.meta.code })
        } else {
          if (route.children) {
            store.dispatch('removeCacheView', { name: route.children[0].meta.name })
            store.dispatch('setTagId', { name: route.children[0].meta.code })
          }
        }
        subRouter = route
        current = route.redirect
      }
      if (subRouter) {
        store.dispatch('getSubRouter', subRouter);
      }
      if (subRouter.children) {
        let length = subRouter.children
        if (subRouterTo) {
          store.dispatch('getSubChildrenRouter', subRouterTo);
          if (length > 1) {
            this.curPageTo = subRouterTo.code
          }
        } else {
          for (let item of subRouter.children) {
            if (item.meta.path == current) {
              store.dispatch('getSubChildrenRouter', item);
              if (length > 1) {
                this.curPageTo = item.code
              }
              break
            }
          }
        }
      }
      this.curPage = subRouter.code
      this.curClick = this.curPage
      this.curClickTo = this.curPageTo
      // if (path){
      // 	this.$router.push({path:path});
      // }
    },
    getBreadcrumb () {
      if (this.$route.meta) {
        this.curHref = this.$route.meta.path
      } else {
        this.curHref = this.$route.path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-nav {
  // width: 230px;
  height: 100%;
  position: fixed;
  top: 80px;
  background: rgba(41, 48, 59, 1);
}
.div-icon {
  width: 40px;
  height: 40px;
  margin-right: auto;
}
.div-icon-max {
  margin-left: auto;
}
.div-icon-min {
  margin-left: 20px;
}
.menu-ul {
  z-index: 100;
  > li {
    cursor: pointer;
    margin-bottom: 10px;
    width: 230px;
    height: 60px;
    z-index: 100;
  }
  .li-min {
    width: 90px;
  }
  .menu-ul-div {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    height: 60px;
  }
  .menu-active {
    background: rgba(72, 78, 87, 1);
    .title {
      width: 125px;
    }
  }
  .title {
    width: 145px;
    height: 20px;
    font-size: 20px;
    //font-family:PingFangSC-Regular;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;
  }
  .slider-div {
    width: 20px;
    height: 60px;
    background: rgba(82, 88, 96, 1);
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    img {
      width: 14px;
      height: 20px;
    }
  }
}
.sub-menu {
  height: 100%;
  position: fixed;
  top: 80px;
  background: rgba(62, 70, 82, 1);
  z-index: 9999;
  li {
    width: 140px;
    height: 60px;
  }
  .sub-active {
    background: rgba(90, 97, 107, 1);
  }
  .menu-sub-div {
    width: 100%;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
  }
  .sub-title {
    height: 25px;
    font-size: 18px;
    //font-family:PingFangSC-Regular;
    color: rgba(255, 255, 255, 1);
    line-height: 25px;
  }
}
.sub-menu-min {
  margin-left: 90px;
}
.sub-menu-max {
  margin-left: 230px;
}
// 标题小图标
.home-icon {
  background: url('../../assets/menu-icon/home-icon.png') no-repeat center
    center;
  background-size: 100%;
}
.agency-icon {
  background: url('../../assets/menu-icon/agency-icon.png') no-repeat center
    center;
  background-size: 100%;
}
.mail-icon {
  background: url('../../assets/menu-icon/mail-icon.png') no-repeat center
    center;
  background-size: 100%;
}
.setup-icon {
  background: url('../../assets/menu-icon/setup-icon.png') no-repeat center
    center;
  background-size: 100%;
}
.project-icon {
  background: url('../../assets/menu-icon/project-icon.png') no-repeat center
    center;
  background-size: 100%;
}
.file-icon {
  background: url('../../assets/menu-icon/file-icon.png') no-repeat center
    center;
  background-size: 100%;
}
.weekly-icon {
  background: url('../../assets/menu-icon/weekly-icon.png') no-repeat center
    center;
  background-size: 100%;
}
.template-icon {
  background: url('../../assets/menu-icon/template-icon.png') no-repeat center
    center;
  background-size: 100%;
}
</style>


// WEBPACK FOOTER //
// src/layout/components/Sidebar.vue